<!-- Breadcumbs Area -->
<div class="bread-cumbs-area bread-cumbs-bg">
    <div class="diplay-table">
        <div class="display-table-cell">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7">
                        <h1>Blog Details</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ac augue at erat hendrerit dictum. Praesent porta, purus eget sagittis imperdiet.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Breadcumbs Area -->

<!-- Start Our blog Area -->
<section id="blog" class="our-blog main-blog">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="blog-details">
                            <div class="post-img">
                                <img src="assets/img/blog-one.jpg" alt="blog-one">
                            </div>

                            <div class="blog-info">
                                <div class="date-box">
                                    28 <span class="month">Jan</span>
                                </div>
                                <div class="title-meta">
                                    <h2>10 hot marketing trends you need.</h2>
                                    <div class="post-meta">
                                        <ul>
                                            <li><i class="fa fa-user"></i> Posted By: <a href="#">Admin</a></li>
                                            <li><i class="far fa-comment"></i> Comments: <a href="#">11</a></li>
                                            <li><i class="fa fa-tags"></i> Tags: <a href="#">Business</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="post-content">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>

                                <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>

                                <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p>

                                <p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?</p>

                                <p>But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness.</p>

                                <p>No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure.</p>

                                <p>To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?</p>
                            </div>

                            <div class="comments-area">
                                <h3 class="comments-title">3 Comments</h3>
                                <div class="single-comment">
                                    <img src="assets/img/comment_1.jpg" alt="" />
                                    <h4>John Smith</h4>
                                    <p class="date">2 days ago</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    <a href="#" class="reply">Reply</a>
                                </div>

                                <div class="single-comment mrl-50">
                                    <img src="assets/img/comment_2.jpg" alt="" />
                                    <h4>Michael Sheen</h4>
                                    <p class="date">2 days ago</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                </div>

                                <div class="single-comment">
                                    <img src="assets/img/comment_3.jpg" alt="" />
                                    <h4>Idris Elba</h4>
                                    <p class="date">2 days ago</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    <a href="#" class="reply">Reply</a>
                                </div>
                            </div>

                            <div class="comments-form">
                                <h3 class="comments-title">Leave a Comments</h3>
                                <form>
                                    <div class="form-group">
                                        <input type="text" class="form-control" id="name" placeholder="Your Name">
                                    </div>
                                    <div class="form-group">
                                        <input type="email" class="form-control" id="email_address" placeholder="Your Email">
                                    </div>
                                    <div class="form-group">
                                        <textarea class="form-control" rows="5" placeholder="Type here..."></textarea>
                                    </div>
                                    <div class="text-center">
                                        <div class="button">
                                            <a href="#">Post a Comment</a>
                                            <div class="mask"></div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <!-- Search form -->
                <div class="side-widget">
                    <div class="search-form">
                        <form>
                            <input type="text" class="form-control" id="search" placeholder="Search">
                            <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
                        </form>
                    </div>
                </div>
                <!-- End Search form -->

                <!-- Recent posts -->
                <div class="side-widget">
                    <h3>Recent posts</h3>
                    <div class="single-post">
                        <a href="#"><img src="assets/img/post_1.jpg" alt="" /></a>
                        <h4><a href="#">10 hot marketing trends you need.</a></h4>
                        <div class="post-meta">
                            <p>Lorem ipsum dolor sit amet, consectetur</p>
                            <ul>
                                <li><i class="fa fa-calendar"></i> Date: 01 Jan</li>
                            </ul>
                        </div>
                    </div>

                    <div class="single-post">
                        <a href="#"><img src="assets/img/post_2.jpg" alt="" /></a>
                        <h4><a href="#">10 hot Themes trends you need.</a></h4>
                        <div class="post-meta">
                            <p>Lorem ipsum dolor sit amet, consectetur</p>
                            <ul>
                                <li><i class="fa fa-calendar"></i> Date: 22 Feb</li>
                            </ul>
                        </div>
                    </div>

                    <div class="single-post">
                        <a href="#"><img src="assets/img/post_3.jpg" alt="" /></a>
                        <h4><a href="#">10 hot Template trends you need.</a></h4>
                        <div class="post-meta">
                            <p>Lorem ipsum dolor sit amet, consectetur</p>
                            <ul>
                                <li><i class="fa fa-calendar"></i> Date: 19 Jan</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- End Recent posts -->

                <!-- Categories -->
                <div class="side-widget">
                    <h3>Categories</h3>
                    <ul class="list-group">
                        <li class="list-group-item"><a href="#">Business</a></li>
                        <li class="list-group-item"><a href="#">Technology</a></li>
                        <li class="list-group-item"><a href="#">Food</a></li>
                        <li class="list-group-item"><a href="#">Family</a></li>
                    </ul>
                </div>
                <!-- End Categories -->

                <!-- Categories -->
                <div class="side-widget">
                    <h3>Tags</h3>
                    <ul class="list-tags">
                        <li><a href="#">Business</a></li>
                        <li><a href="#">Family</a></li>
                        <li><a href="#">Technology</a></li>
                        <li><a href="#">Family</a></li>
                        <li><a href="#">Food</a></li>
                        <li><a href="#">Business</a></li>
                        <li><a href="#">Family</a></li>
                        <li><a href="#">Technology</a></li>
                        <li><a href="#">Business</a></li>
                        <li><a href="#">Technology</a></li>
                    </ul>
                </div>
                <!-- End Categories -->
            </div>
        </div>
    </div>
</section>
<!-- End Our blog Area -->
